import { LoadingButton as Button, LoadingButtonProps } from '@mui/lab';
import styled from 'styled-components';

interface StyledButtonProps extends LoadingButtonProps {
  $allCaps?: boolean;
  $rounded?: boolean;
  $disableHover?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const StyledButton = styled(Button)<StyledButtonProps>`
  && {
    text-transform: ${({ $allCaps }) => !$allCaps && 'none'};
    font-family: ${({ theme }) => theme.typography.button.fontFamily};
    padding: ${({ theme, size }) => size !== 'small' && theme.spacing(1, 4)};
    border-radius: ${({ theme, $rounded }) => $rounded && theme.shape.borderRadius * 3}px;
  }
`;

export { StyledButton };
